import { NicknameUnderlinedBig } from '@/components/DybrComponents/NicknameDisplay';
import BlogDisplayContainer from '@/components/Shared/BlogDisplayContainer';
import {
  banProfile,
  unbanProfile,
  unhideProfile
} from '@/store/lists/operations';
import { selectProfileIsBanned } from '@/store/lists/selectors/selectProfileIsBanned';
import { selectProfileIsHidden } from '@/store/lists/selectors/selectProfileIsHidden';
import { useTokenState } from '@/store/localStorage/useTokenState';
import { selectIsOwnProfile } from '@/store/user/selectors/selectIsOwnProfile';
import { BlockUserIcon } from '@/styles/Icons/BlockUser';
import JournalIcon from '@/styles/Icons/Journal';
import ProfileIcon from '@/styles/Icons/Profile';
import { useDispatch, useSelector } from 'react-redux';
import MessageEnvelope from '../../../styles/Icons/MessageEnvelope';
import { BlockUserDisplay, IconButton, Wrapper } from './Styled';

export function AvatarMenu({ profile }) {
  const dispatch = useDispatch();

  const [token] = useTokenState();
  const isUserLoggedIn = Boolean(token);

  const id = profile.id;
  const isBanned = useSelector(state => selectProfileIsBanned(state, id));
  const isHidden = useSelector(state => selectProfileIsHidden(state, id));
  const isOwnProfile = useSelector(state =>
    selectIsOwnProfile(state, { profileId: id })
  );

  const toggleBan = () => {
    isBanned
      ? dispatch(unbanProfile({ profile, token }))
      : dispatch(banProfile({ profile, token }));
  };

  return (
    <Wrapper>
      <ul className="icon-positioning">
        <li>
          <IconButton to={`/profile/${profile.id}`} title="профиль">
            <ProfileIcon />
          </IconButton>
        </li>
        <li>
          <IconButton to={`/blog/${profile.blogSlug}`} title="блог">
            <JournalIcon />
          </IconButton>
        </li>
        <li>
          <IconButton to={`/direct/${profile.id}`} title="личные сообщения">
            <MessageEnvelope />
          </IconButton>
        </li>
        {/* <li>
          <IconButton
            href={`/blog/${profile.blogSlug}/favorites`}
            title="избранное"
          >
            <FavoritesIcon />
          </IconButton>
        </li> */}
      </ul>
      <NicknameUnderlinedBig profile={profile} />

      {/*<ListsDisplay>
            <ul className="list-positioning">
              <li>в списках:</li>
              <li>friend</li>
              <li>work</li>
              <li>jrock</li>
            </ul>
            <Button href={`${blog.url}`} className="menu-add-to-list">
              добавить в список
            </Button>
          </ListsDisplay>*/}

      <BlogDisplayContainer profile={profile} />

      {isUserLoggedIn && (
        <BlockUserDisplay>
          {!isOwnProfile && (
            <IconButton
              className="block-user-link"
              onClick={toggleBan}
              title={
                isBanned
                  ? 'пользователь не видит ваши записи'
                  : 'пользователь не будет видеть ваши записи'
              }
            >
              <BlockUserIcon />
              <span>
                {isBanned
                  ? 'разблокировать пользователя'
                  : 'заблокировать пользователя'}
              </span>
            </IconButton>
          )}
        </BlockUserDisplay>
      )}
      {isHidden ? (
        <BlockUserDisplay>
          <IconButton
            className="show-in-feed"
            onClick={() => dispatch(unhideProfile({ profile, token }))}
          >
            <span>вернуть в общую ленту</span>
          </IconButton>
        </BlockUserDisplay>
      ) : null}
    </Wrapper>
  );
}
